import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import classNames from 'classnames'
import {useHref} from 'react-router-dom'

import {objectToQuery} from '../../../../../../utils/queryParams'
import IconButton from '../../../../../common/IconButton/IconButton'
import Popup from '../../../../../common/Popup/Popup.lazy'
import {PointType} from '../../../BuildLog.types'
import {getFullBuildLogLinkParams} from '../../../BuildLog.utils'

import type {Props} from './TimelinePoint.types'

import styles from './TimelinePoint.css'

const popupDirections = [Directions.RIGHT_TOP, Directions.LEFT_TOP]
export default function TimelinePoint({
  buildId,
  buildAnchor,
  name,
  type,
  logTarget,
  style,
  onMouseEnter,
  onMouseLeave,
  onClick,
}: Props) {
  const href = useHref({
    search: objectToQuery(
      getFullBuildLogLinkParams({
        buildId,
        line: buildAnchor,
        expandState: [buildAnchor],
        target: logTarget,
        expandAll: false,
      }),
    ),
  })
  // const onClick = useLinkClickHandler(to)
  const anchor = (
    <IconButton
      href={href}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      className={styles.pointButton}
      iconClassName={styles.pointIcon}
      icon="exception"
      special
    />
  )
  return (
    <Dropdown
      className={styles.wrapper}
      style={style}
      anchor={anchor}
      hoverMode
      clickMode={false}
      hoverHideTimeOut={0}
      hoverShowTimeOut={0}
    >
      <Popup directions={popupDirections} top={-8} className={styles.popup} trapFocus={false}>
        <div
          className={classNames(styles.popupContent, {
            [styles.failure]: type === PointType.FAILURE,
          })}
        >
          {name ??
            `${type === 'FAILURE' ? 'Failure' : 'Unknown event'} on line ${buildAnchor.toString()}`}
        </div>
      </Popup>
    </Dropdown>
  )
}
